<template>
    <div>
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <h1 class="title is-3">
                        <b-icon
                            icon="pipe-valve" />
                        Piping Class & Size
                    </h1>
                </div>
            </div>
            <div class="level-left">
                <div class="level-item subtitle">
                    <strong>{{ subTitle }}</strong>
                </div>
            </div>
        </div>
        <div class="level is-mobile">
            <div class="level-left">
                <scope-dropdown
                    scope-type="Facility" />
            </div>
            <b-tooltip
                class="level-right"
                label="View piping class sheet">
                <b-button
                    v-if="showTR2000"
                    class="level-item button is-info"
                    @click="openTR2000Link">
                    <i class="mdi mdi-open-in-new" />
                    TR2000 PCS
                </b-button>
            </b-tooltip>
        </div>
        <hr>
        <b-tabs
            v-model="activeTab"
            type="is-boxed"
            style="margin-top: 10px">
            <b-tab-item
                label="Piping Class"
                value="Class">
                <piping-class-tab
                    :view-valid-only="viewValidOnly"
                    @navigateToPipingClassTab="onNavigateToPipingClassSizeTab" />
            </b-tab-item>
            <b-tab-item
                label="Piping Class Size"
                value="ClassSize">
                <piping-class-size-tab
                    :view-valid-only="viewValidOnly" />
            </b-tab-item>
            <b-tab-item
                label="Line Size"
                value="LineSize">
                <line-size-tab
                    :view-valid-only="viewValidOnly" />
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script lang="ts" setup>
    import LineSizeTab from './LineSizeTab.vue';
    import PipingClassTab from './PipingClassTab.vue';
    import ScopeDropdown from '@/shared/components/ScopeDropdown.vue';
    import { usePipeClassStore } from '@/stores/pipeClassStore.ts';
    import { computed, onMounted, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import PipingClassSizeTab from '@/apps/STID_Pipe/PipingClassSizeTab.vue';

    const router = useRouter();
    const pipeClassStore = usePipeClassStore();
    const activeTab = ref<string>('');
    const viewValidOnly = ref<boolean>(true);

    const props = withDefaults(defineProps<{
        selectedTab?: string;
    }>(), {
        selectedTab: 'Class'
    });

    const subTitle = computed<string>(() => {
        if (pipeClassStore.selectedScope && !pipeClassStore.selectedPipingClass) {
            return pipeClassStore.selectedScope;
        } else if (pipeClassStore.selectedScope && pipeClassStore.selectedPipingClass) {
            return `${pipeClassStore.selectedScope} / ${pipeClassStore.selectedPipingClass.Identity}`;
        } else {
            return '';
        }
    });
    const showTR2000 = computed<boolean>(() => {
        return !!(pipeClassStore.selectedScope && pipeClassStore.selectedPipingClass?.Identity);
    });

    watch(activeTab, (value) => {
        const destination = {
            name: 'PipeClassEditor',
            params: { selectedTab: value }
        };
        router.replace(destination);
    });

    watch(() => pipeClassStore.selectedScope, async () => {
        await pipeClassStore.init();
    });

    onMounted(async () => {
        await pipeClassStore.init();

        activeTab.value = props.selectedTab;
    });

    function onNavigateToPipingClassSizeTab() {
        activeTab.value = 'ClassSize';
    }

    function openTR2000Link() {
        if (pipeClassStore.selectedScope && pipeClassStore.selectedPipingClass) {
            const url = `https://tr2000.equinor.com/TR2000/integration/get_datasheet.jsp?SYS=STID&DS=PCS&ID=${pipeClassStore.selectedPipingClass.Identity}&PLANT=${pipeClassStore.selectedScope}`;
            window.open(url, '_blank', 'noopener');
        }
    }

</script>

<style scoped>
</style>
